// Phase 5 results endpoints: the audit workbook and the search's versions.
// PolarisApi extends this class, so callers keep using polarisApi.getVersions()
// etc.; split out of index.ts to keep that file within the repo's per-file size
// budget.
import {TSearchVersionsResponse, TVersionChangesResponse} from "api/polarisApi/types";
import PolarisFootprintApi from "./footprintApi";

export const XLSX_MIME = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

class PolarisSearchResultsApi extends PolarisFootprintApi {
	// The workbook (Final list, Ruled out, Companies, Summary) as a Blob. Goes
	// through the shared client, so the user's token is attached.
	async getAuditXlsx(searchId: string, requestConfig = {}) {
		return this.doGet<Blob>(`/polaris/searches/${searchId}/audit.xlsx`, {
			responseType: "blob",
			headers: {Accept: XLSX_MIME},
			...requestConfig,
		});
	}

	async getVersions(searchId: string, requestConfig = {}) {
		return this.doGet<TSearchVersionsResponse>(
			`/polaris/searches/${searchId}/versions`,
			requestConfig,
		);
	}

	// Who `version` added and removed compared with `against` (by default the
	// previous finished version). 409 when either has not finished, or when there
	// is no earlier finished version.
	async getVersionChanges(
		searchId: string,
		version: number,
		against?: number | null,
		requestConfig = {},
	) {
		const againstQuery = against != null ? `?against=${against}` : "";

		return this.doGet<TVersionChangesResponse>(
			`/polaris/searches/${searchId}/versions/${version}/changes${againstQuery}`,
			requestConfig,
		);
	}
}

export default PolarisSearchResultsApi;
